import moment from "moment";

export const humanFriendlyDate = (v: Date | string) => {
  const d = moment(v);

  return d.format("MMM D, YYYY");
};
